'use client';
import React from "react";
import { useEffect, useState, useMemo, useRef, lazy } from "react";
import { Image, isNextBuild } from '@/lib/target';
import WIN from "@/assets/images/win.svg";
import DRAW from "@/assets/images/draw.svg";
import LOSE from "@/assets/images/lose.svg";
import { BXH_LEAGUES } from "@/contants";
import { useRouter } from '@/lib/target'; // Next.js router for navigation
import ICON_ARROW_DOWN_LIGHT from "@/assets/images/Arrow_drop_down_blue_light_mode.svg";
import ICON_ARROW_DOWN_DARK from "@/assets/images/Arrow_drop_down_white_dark_mode.svg";
import { useTheme } from "@/context/ThemeContext";
import { useIsMobile } from "@/lib/isMobile";
import "./leagueStanding.scss";
const LeagueStandingHeader = lazy(() => import("../LeagueStandingHeader"));
const NoData = lazy(() => import("../NoData"));

const LeagueStanding = ({ leagueId, standings, leagueType, showDropdown = true }) => {
  const [activeTab, setActiveTab] = useState('totalStandings');
  const [data, setData] = useState([]);
  const types = useMemo(() => Object.keys(standings || {}), [standings]); 
  
  useEffect(() => {
    if (standings && types.length > 0) {
      const defaultTab = types.includes('totalStandings') ? 'totalStandings' : types[0];
      setActiveTab(defaultTab);
      setData(standings[defaultTab]);
    }
  }, [standings, types]);

  useEffect(() => {
    if (activeTab && standings) {
      setData(standings[activeTab]);
    }
  }, [activeTab, standings]);

  // if (!standings) {
  //   return <NoData />;
  // }

  const renderStandingLabel = (type) => {
    const labels = {
      totalStandings: "Tổng quan",
      homeStandings: "Sân nhà",
      awayStandings: "Sân khách",
    };
    return labels[type] || "";
  };
  
  return (
    <div className="rounded w-full mx-auto mt-4 px-2 @lg:px-7 pb-5">
      {(standings.totalStandings.length === 0) ? (
        <>
        {showDropdown && (
          <div className="@md:hidden w-full"> 
            {isNextBuild ? (<LeaguesDropdown items={BXH_LEAGUES} itemId={leagueId.id}/>) : (<></>)}
          </div>
        )}

        <NoData />
        </>
      ) : (
        <>
        {showDropdown && (
          <div className="@md:hidden w-full"> 
           {isNextBuild ? (<LeaguesDropdown items={BXH_LEAGUES} itemId={leagueId.id}/>) : (<></>)}
          </div>
        )}
        
        <ul id="tabs" className="inline-flex pt-2 w-full border-b mb-2 @lg:mb-4 border-button-blue-bet dark:border-midnight-slate gap-2 @lg:gap-3 pb-px justify-between @lg:justify-start">
          {types.map((item) => {
            if (renderStandingLabel(item) === "") {
              return; 
            }
            return (
              <li
                key={item}
                className={`w-full @lg:w-auto h-6 text-gray-800 font-medium flex items-center cursor-pointer justify-center rounded-t hover:bg-button-blue-bet hover:text-white -mb-px ${
                  activeTab === item ? 'bg-button-blue-bet dark:bg-large-blue text-white -mb-px' : 'bg-default-blue dark:bg-midnight-slate dark:text-white'
                }`}
              >
                <button className="text-xxs @lg:text-xs px-4 w-full" onClick={() => setActiveTab(item)}>
                  {renderStandingLabel(item)}
                </button>
              </li>
            )
          })}
        </ul>
        <div className=""> 
          <LeagueStandingHeader item={standings?.league}/>
        </div>
        <div id="tab-contents">
          <LeagueStandingItem data={data} leagueType={leagueType} />
        </div>
        </>
      )}
      
    </div>
  );
};

export const LeagueStandingItem = ({ data, leagueType }) => {
  if (!data || data.length === 0) {
    return <NoData />;
  }
  const renderMatchResult = (key) => {
    const icons = {
      '0': WIN,
      '1': DRAW,
      '2': LOSE,
    };

    return icons[key] ? <Image alt="Net88" src={icons[key]} width={16} height={16} /> : null;
  };
  
  return (
    <div className="text-center">
      <div className="flex w-full grow justify-between h-7 bg-white dark:bg-midnight-slate items-center pr-4 !text-xxs @lg:!text-xs">
        <div className="w-72 flex">
          <div className="w-7 @lg:w-12">#</div>
          <div className="@lg:w-full text-left flex w-[130px]">Đội</div>
        </div>
        <div className="w-28 hidden @lg:flex justify-center">Số trận</div>
        <div className="flex w-32 justify-between">
          <div className="w-7">Thắng</div>
          <div className="w-7">Hòa</div>
          <div className="w-7">Bại</div>
        </div>
        <div className="hidden @lg:flex w-20 justify-between">
          <div className="w-7">BT</div>
          <div className="w-7">BB</div>
          <div className="w-7 text-right">HS</div>
        </div>
        <div className="w-10">Điểm</div>
        {data[0]?.type === '1' && <div className="hidden @lg:flex w-24">5 trận gần nhất</div>}
      </div>
      <div>
      {data.sort((a, b) => a.rank - b.rank).map((item, index) => {
        const isLastThree = (index + 1) - data.length > -3;
        const isChampionsLeague = index <= 3;
        const isEuropaLeague = index === 4;
        const itemClass = `pr-4 flex w-full grow justify-between h-8 
        even:bg-header-blue dark:even:bg-midnight-slate items-center odd:bg-white-3 dark:odd:bg-dark-slate border-solid border-l-2 
        ${isLastThree ? ' border-vibrant-red mb-px' : isChampionsLeague ? 'border-medium-green mb-px' : isEuropaLeague ? 'border-golden-yellow mb-px' : ''}`;
        return (
          
          <div key={index} className={itemClass}>
            <div className="w-72 flex">
              <div className="w-7 @lg:w-12">{item.rank}</div>
              <div className="@lg:w-full text-left flex w-[130px] ">
                <Image alt="Net88" src={item.teams.logo || 'https://demofree.sirv.com/nope-not-here.jpg'} width={20} height={20} />
                <span className="ml-2 text-xxs @lg:text-xs text-ellipsis text-nowrap overflow-hidden">{item.teams.name}</span>
              </div>
            </div>
            
            <div className="w-28 font-bold hidden @lg:flex justify-center">{item.totalCount}</div>
            <div className="flex w-32 justify-between">
              <div className="w-7">{item.winCount}</div>
              <div className="w-7">{item.drawCount}</div>
              <div className="w-7">{item.loseCount}</div>
            </div>
            <div className="hidden @lg:flex w-20 justify-between">
              <div className="w-7">{+item.loseScore + +item.goalDifference }</div>
              <div className="w-7">{item.loseScore}</div>
              <div className="w-7 text-right">{(item.goalDifference > 0) ? (`+${item.goalDifference}` ) : item.goalDifference }</div>
            </div>
            <div className="w-10 font-bold">{+item.winCount*3 + +item.drawCount}</div>
  
            {item.type === '1' && (
              <div className="w-24 hidden @lg:flex justify-between items-center">
                {/* <span className="rounded-full bg-button-blue-bet text-xxs w-3 h-3 flex justify-center items-center text-white">?</span> */}
                {[item.recentSixthResult, item.recentFifthResult, item.recentFourthResult, item.recentThirdResult, item.recentSecondResult].map((result, idx) => (
                  <span key={idx}>{renderMatchResult(result)}</span>
                ))}
              </div>
            )}
          </div>
        )
      }
      )
      }
      </div>
    </div>
  );
};

export const LeaguesDropdown = ({ items, itemId, type="league", handlerFunc}) => {
  const { theme } = useTheme();
  const leagueSlug = type === "league" ? items.find((item) => +item.id === +itemId) : null;
  const popoverRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const router = useRouter(); 
  const isMobile = useIsMobile();
  const [selectedItem, setSelectedItem] = useState(leagueSlug ? leagueSlug.slug : itemId);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChangeItem = (item) => {
    if(type === "league"){
      setSelectedItem(item.slug);
      router.push(`/bang-xep-hang/${item.slug}`);
    }
    if(type === "season"){
      handlerFunc(item)
      setSelectedItem(item);
    }
    handleVisible(false);
  };

  const togglePopover = () => {
    handleVisible(!isVisible);
  };

  const handleVisible = (visible) => {
    if (isMobile) {
      if (visible) {
        document.body.classList.remove('keobongvip-root');
      } else {
        document.body.classList.add('keobongvip-root');
      }
    }
    setIsVisible(visible);
  };

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      handleVisible(false);
    }
  };

  return (
    <div className="select-button-league w-full relative inline-block">
      <button onClick={togglePopover}
        className="relative flex items-center my-1.5 @lg:my-4 @lg:px-1 w-full font-montserrat font-semibold text-button-blue-bet text-xs dark:bg-black dark:text-stroke-o3 pr-1 rounded-md h-6 border border-button-blue-bet text-center">
        <span className="absolute left-1/2 transform -translate-x-1/2">{leagueSlug ? leagueSlug.name : itemId}</span>
        <Image
          alt="Net88"
          src={
            theme === 'dark'
              ? ICON_ARROW_DOWN_DARK
              : ICON_ARROW_DOWN_LIGHT
          }
          width={12}
          height={12}
          className="ml-auto w-6 h-6 hover:cursor-pointer"
        />
      </button>
      {isVisible && (
        <div className="overlay" onClick={() => handleVisible(false)}></div>
      )}
      <div className={`popup ${isVisible ? "visible" : ""}`} ref={popoverRef}>
        <div className="text-gray-700 dark:text-league-dark-detail">
          <div className="bg-white-half dark:bg-league-white rounded-lg">
            {items.length > 0 &&
              items.map((item, index) => (
                <div
                  key={index}
                  className={`cursor-pointer p-2 text-dark-gray dark:text-stroke-o3 hover:bg-yellow-pastel rounded-lg ${index % 2 !== 0 && "bg-vr-light-gray dark:bg-dark-slate "
                    } hover:bg-yellow-pastel dark:hover:bg-league-gray-dark ${(selectedItem === item.slug || selectedItem === item) && "bg-yellow-pastel dark:bg-golden-yellow dark:text-midnight-slate"} `}
                  onClick={() => {
                    handleChangeItem(item) 
                  }}
                >
                  {item.name || item}
                </div>
              ))}
          </div>
          <div style={{ marginTop: '0.15rem' }} className="px-8 py-4 bg-header-blue rounded-md dark:bg-league-white">
            <button
              className="rounded w-full text-blur-gray bg-white-3 dark:bg-dark-slate dark:text-stroke-o3 p-3"
              onClick={togglePopover}
            >
              Đóng
            </button>
          </div>
        </div>
      </div>
    </div>  
  );
};
export default React.memo(LeagueStanding);
